import React from 'react';
import PropTypes from 'prop-types';
import spotifyLogo from '../images/Spotify_Icon_RGB_Black.png';

const Meta = (props) => {
  const spotifyLink = `https://open.spotify.com/track/${props.spotifyUri}`;
  const title = `Play ${props.song} by ${props.artist} on Spotify`;
  return (
    <a href={spotifyLink} target="_blank" className="meta" title={title}>
      <h2 className="meta__heading  truncate">{props.artist}</h2>
      <h3 className="meta__sub-heading  truncate">{props.song}</h3>
      <div className="meta__play">
        <img className="meta__spotify" src={spotifyLogo} alt="Spotify" />
      </div>
    </a>
  );
};

Meta.propTypes = {
  artist: PropTypes.string.isRequired,
  song: PropTypes.string.isRequired,
  spotifyUri: PropTypes.string.isRequired,
};

export default Meta;



// WEBPACK FOOTER //
// ./src/components/Meta.js